import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SettingField } from "@/components/settings/setting-field";
import { FormControl, FormField, FormItem } from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import type { SaveField } from "../../../hooks/use-auto-save-field";
import { SalonConfig } from "../hooks/use-salon-config";

export function AppointmentAssignmentToggle({
  saveField,
  saving,
}: {
  saveField: SaveField<SalonConfig>;
  saving: boolean;
}) {
  const { control } = useFormContext<SalonConfig>();
  const { t } = useTranslation("settings");

  return (
    <div className="space-y-4">
      <FormField
        control={control}
        name="appointmentWorkerAssignmentEnabled"
        render={({ field }) => (
          <FormItem id="field-salon-worker-assignment">
            <SettingField
              label={t("salonConfig.fields.workerAssignment.label")}
              helpText={t("salonConfig.fields.workerAssignment.helpText")}
              helpDetails={
                <div className="space-y-2">
                  <div className="text-sm font-medium text-foreground">
                    {t("salonConfig.fields.workerAssignment.helpDetails.title")}
                  </div>
                  <ul className="text-sm space-y-1 text-muted-foreground">
                    {(
                      t("salonConfig.fields.workerAssignment.helpDetails.benefits", {
                        returnObjects: true,
                      }) as string[]
                    ).map((benefit: string, index: number) => (
                      <li key={index}>• {benefit}</li>
                    ))}
                  </ul>
                </div>
              }
            >
              <FormControl>
                <Switch
                  checked={field.value}
                  disabled={saving}
                  onCheckedChange={(value) => {
                    void saveField("appointmentWorkerAssignmentEnabled", value);
                  }}
                />
              </FormControl>
            </SettingField>
          </FormItem>
        )}
      />
    </div>
  );
}
